export const calculateShowEditorAlways = (
	showEditorAlways: boolean,
	dataGridEditingMode: string
) => {
	if (dataGridEditingMode === 'row') {
		return false;
	}
	return showEditorAlways;
};
